import {} from "@lumora/bridge";
import { Ticket } from "../models/Ticket.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** TicketListViewModel powers the support-ticket list and creation form. */
export class TicketListViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ tickets: [], loading: false, error: null });
        this.client = client;
    }
    async load() {
        await this.run(async () => {
            const raw = await this.client.listTickets();
            const tickets = raw.map((r) => new Ticket(r.id, r.type, r.description, r.status, r.createdAt));
            this.setState({ tickets });
        }, "Failed to load tickets.");
    }
    async create(input) {
        const ok = await this.run(async () => {
            await this.client.createTicket(input);
            await this.load();
            return true;
        }, "Failed to create ticket.");
        return ok === true;
    }
}
//# sourceMappingURL=TicketListViewModel.js.map